export const esTools = {
  'tools.allWallets': 'Todas las wallets',
  'tools.annualDescription': 'Saldo acumulado, ingresos y gastos distribuidos mes a mes.',
  'tools.annualExpenses': 'Gastos proyectados del año',
  'tools.annualTitle': 'Proyección anual',
  'tools.balanceChartDescription': 'Cuánto tendrías al cierre de cada mes si nada cambia.',
  'tools.balanceChartLabel': 'Proyección mensual de {year}; cierre estimado {end}.',
  'tools.balanceChartTitle': 'Evolución del saldo',
  'tools.cashflowChartDescription': 'Compara lo que entra y sale cada mes.',
  'tools.cashflowChartTitle': 'Ingresos frente a gastos',
  'tools.dashboardDescription': 'Entiende el año completo sin convertirlo en una hoja de cálculo.',
  'tools.expenseBreakdown': 'Gastos por categoría',
  'tools.expenseDescription': 'Proyección de {year} para {wallet}, usando tus recurrencias reales.',
  'tools.filterDescription':
    'Cambia el año o enfoca una wallet; la gráfica se actualiza al instante.',
  'tools.filterTitle': 'Filtrar análisis',
  'tools.highestMonth': 'Saldo más alto',
  'tools.lowestMonth': 'Punto más bajo',
  'tools.monthCashflowLabel': '{month}: ingresos {income}, gastos {expenses}.',
  'tools.monthlyClosingBalances': 'Saldos al cierre de cada mes',
  'tools.noExpenses': 'No hay gastos proyectados para este filtro.',
  'tools.wallet': 'Wallet',
  'tools.yearEnd': 'Cierre del año',
} as const;

export const enTools: Record<keyof typeof esTools, string> = {
  'tools.allWallets': 'All wallets',
  'tools.annualDescription': 'Cumulative balance, income, and expenses distributed month by month.',
  'tools.annualExpenses': 'Projected yearly expenses',
  'tools.annualTitle': 'Annual projection',
  'tools.balanceChartDescription': 'What you would have at each month end if nothing changes.',
  'tools.balanceChartLabel': 'Monthly projection for {year}; estimated close {end}.',
  'tools.balanceChartTitle': 'Balance evolution',
  'tools.cashflowChartDescription': 'Compare what comes in and goes out each month.',
  'tools.cashflowChartTitle': 'Income versus expenses',
  'tools.dashboardDescription': 'Understand the full year without turning it into a spreadsheet.',
  'tools.expenseBreakdown': 'Expenses by category',
  'tools.expenseDescription': '{year} projection for {wallet}, using your actual recurrences.',
  'tools.filterDescription': 'Change the year or focus a wallet; the chart updates instantly.',
  'tools.filterTitle': 'Filter analysis',
  'tools.highestMonth': 'Highest balance',
  'tools.lowestMonth': 'Lowest point',
  'tools.monthCashflowLabel': '{month}: income {income}, expenses {expenses}.',
  'tools.monthlyClosingBalances': 'Month-end balances',
  'tools.noExpenses': 'There are no projected expenses for this filter.',
  'tools.wallet': 'Wallet',
  'tools.yearEnd': 'Year end',
};
